const PrimaryBtn = ({
  text = "Click Me",
  onClick,
  spanClass = "",
  secondSpanClass = "",
  isSubmitting = false,
  disabled = false,
  myClass = "",
}) => {
  return (
    <button
      
      onClick={onClick}
      disabled={disabled || isSubmitting}
      type="submit"
      className={`group relative text-sm sm:text-base sm:!py-4 !py-3.5 px-8 ff-sans rounded-full bg-[#FF5858] border border-[#FF5858] cursor-pointer font-medium overflow-hidden transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed ${myClass}`}
    >
      <span
        className={`z-10 relative group-hover:text-[#FF5858] text-white${spanClass}`}
      >
        {isSubmitting ? "Submitting..." : text}
      </span>
      <span
        className={`absolute left-0 top-0 h-full w-0 group-hover:w-full bg-white transition-all duration-300 ease-in-out z-0 rounded-full ${secondSpanClass}`}
      ></span>
    </button>
  );
};

export default PrimaryBtn;
